import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { Show } from 'www-cms';
import { RouterLink } from '@angular/router';
import { Store } from '@ngxs/store';
import { HeaderActions, ShellState, ShellStateModel } from '../../shell.state';

@Component({
  selector: 'ss-www-theater-shows-list',
  imports: [CommonModule, NgOptimizedImage, RouterLink],
  templateUrl: './theater-shows-list.component.html',
  styleUrls: ['./theater-shows-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TheaterShowsListComponent {
  @Input({ required: true }) theaterName: string = '';
  @Input({ required: true }) theater!: 'lancaster' | 'branson';
  @Input() initialFocus = false;
  private store = inject(Store);
  shellState$ = this.store.select<ShellStateModel>(ShellState.shellState);

  showTrackBy(index: number, show: Show): number {
    return show.id;
  }

  dispatchShowLinkClicked() {
    this.store.dispatch(new HeaderActions.ShowLinkClicked());
  }
}
